// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { UserService } from '@daml.js/utility-credential-app-v0/lib/Utility/Credential/App/V0/Service/User';
import { ERR_DIST_CRED_BILL, SUC_DIST_CRED_BILL } from '../../../../utils/strings';

const useDistributeAmulet = () => {
  const { submit } = useExerciseSubmission(
    UserService.UserService_DistributeAndAdjustDeposit,
    SUC_DIST_CRED_BILL,
    ERR_DIST_CRED_BILL,
  );

  return submit;
};

export default useDistributeAmulet;
